import React, { PropsWithChildren, useState } from 'react';
import { Alert, Text } from '@amzn/storm-ui';
import styled from 'styled-components';
import { AlertVariant } from '@flexible-reports/components/feedback/alert.types';

export interface AlertBannerProps extends PropsWithChildren {
  variant: AlertVariant;
  header: string;
  description: React.ReactNode;
  withCloseButton?: boolean;
}

const StyledAlert = styled(Alert)`
  width: 100%;
`;

const AlertBanner = ({ variant, header, description, withCloseButton = false, children }: AlertBannerProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleBannerClose = () => {
    setIsOpen(false);
  };

  return (
    <StyledAlert variant={variant} header={header} withCloseButton={withCloseButton} isOpen={isOpen} onClose={handleBannerClose}>
      {/* @ts-expect-error `as` is not properly typed on Storm components */}
      {description && <Text as='span'>{description}</Text>}
      {children}
    </StyledAlert>
  );
};

export { AlertBanner };
